import React from 'react';
import { Input as BaseInput, SIZE } from 'baseui/input';

const getInputFontStyle = ({ $theme }) => {
  return {
    color: '#cfd1d7',
    backgroundColor: '#2d3239',
    caretColor: '#cfd1d7',
    ...$theme.typography.fontBold14,
  };
};

const Input = ({ ...props }) => {
  return (
    <BaseInput
      overrides={{
        Input: {
          style: ({ $theme }) => {
            return {
              ...getInputFontStyle({ $theme }),
              '::placeholder': {
                color: 'rgba(142, 148, 160, 0.6)',
              },
            };
          },
        },
        Root: {
          style: ({ $isFocused }) => ({
            borderTopWidth: '1.5px',
            borderBottomWidth: '1.5px',
            borderLeftWidth: '1.5px',
            borderRightWidth: '1.5px',
            borderTopStyle: 'solid',
            borderBottomStyle: 'solid',
            borderLeftStyle: 'solid',
            borderRightStyle: 'solid',
            borderTopColor: $isFocused ? 'rgba(0, 197, 141, 0.5)' : 'rgba(255, 255, 255, 0.06)',
            borderBottomColor: $isFocused ? 'rgba(0, 197, 141, 0.5)' : 'rgba(255, 255, 255, 0.06)',
            borderLeftColor: $isFocused ? 'rgba(0, 197, 141, 0.5)' : 'rgba(255, 255, 255, 0.06)',
            borderRightColor: $isFocused ? 'rgba(0, 197, 141, 0.5)' : 'rgba(255, 255, 255, 0.06)',
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
            borderBottomLeftRadius: '10px',
            borderBottomRightRadius: '10px',
            backgroundColor: '#2d3239',
            boxShadow: $isFocused ? '0 0 0 3px rgba(0, 197, 141, 0.1)' : 'none',
            transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
          }),
        },
        InputContainer: {
          style: () => ({
            backgroundColor: '#2d3239',
          }),
        },
        ClearIcon: {
          style: () => ({
            backgroundColor: 'transparent',
            color: 'rgba(207, 209, 215, 0.6)',
            ':hover': {
              color: '#cfd1d7',
            },
          }),
        },
        EndEnhancer: {
          style: () => ({
            backgroundColor: '#2d3239',
            color: 'rgba(207, 209, 215, 0.5)',
          }),
        },
      }}
      {...props}
    />
  );
};

export { SIZE };
export default Input;
